import React, { FunctionComponent } from 'react';

import Form from './Form';

const Upi: FunctionComponent<{
  paymentInfo: any;
  amount: number;
  type: string;
  updateInternetCharges: Function;
  internetCharges: number;
  fromFastag: any;
}> = ({ paymentInfo, amount, type, updateInternetCharges, internetCharges, fromFastag }) => {
  return (
    <div>
      <Form
        paymentInfo={paymentInfo}
        amount={amount}
        type={type}
        updateInternetCharges={updateInternetCharges}
        internetCharges={internetCharges}
        fromFastag={fromFastag}
      />
    </div>
  );
};

export default Upi;
